import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import OrderProp from '../../shop/propTypes/orderProp';
import MainSection from './components/MainSection';
import SubSection from './components/SubSection';

function HeaderSection(props) {
  const { opportunity } = props;

  return (
    <div className="m-portlet header-section">
      <MainSection opportunity={opportunity} />
      <SubSection opportunity={opportunity} />
    </div>
  );
}

HeaderSection.propTypes = {
  opportunity: PropTypes.shape(OrderProp.propType).isRequired,
};

export default translate(HeaderSection);
